import * as React from "react";
import {
  Create,
  SimpleForm,
  SelectInput,
  ReferenceInput,
  required,
  TextInput,
  AutocompleteInput,
} from "react-admin";
import { JsonInput } from "react-admin-json-view";
import {
  MERCHANT_PAYMENT_GATEWAY_STATUSES,
  PAYMENT_GATEWAY_STATUSES,
} from "@local/app/constants/index.js";
import { CustomToolbar } from "../../shared/components/index.js";

const CreateLogo = () => {
  const renderOptionText = (record) => (
    <span key={record.id}>
      <img
        src={record.url}
        alt={record.name}
        width={15}
        height={15}
        style={{ marginRight: "5px" }}
      />
      {record.name}
    </span>
  );

  return (
    <ReferenceInput source="logo_file_id" reference="File">
      <AutocompleteInput
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
        inputText={(record) => record.name}
        optionText={renderOptionText}
        optionValue="id"
        debounce={10}
        validate={[required()]}
        filterToQuery={(searchText) => ({ name: searchText })}
      />
    </ReferenceInput>
  );
};

const createMerchantPaymentGateway = () => {
  const merchant = localStorage.getItem("name");

  return (
    <Create redirect="show">
      <SimpleForm toolbar={<CustomToolbar />}>
        <ReferenceInput
          source="payment_gateway_id"
          reference="PaymentGateway"
          filter={{ status: PAYMENT_GATEWAY_STATUSES.active.name }}
        >
          <SelectInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            optionText="name"
            optionValue="id"
            source="payment_gateway_id"
            validate={[required()]}
          />
        </ReferenceInput>
        <TextInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="name"
          validate={[required()]}
          inputProps={{ maxLength: 64 }}
        />
        {merchant === "PetrolCard" && <CreateLogo />}
        <JsonInput
          source="config"
          reactJsonOptions={{
            name: null,
            collapsed: false,
            enableClipboard: false,
            displayDataTypes: false,
          }}
        />
        <SelectInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="status"
          validate={[required()]}
          choices={Object.keys(MERCHANT_PAYMENT_GATEWAY_STATUSES)
            .filter(
              (status) =>
                status !== MERCHANT_PAYMENT_GATEWAY_STATUSES.blocked.name
            )
            .map((status) => ({
              id: status,
              name: `resources.Merchant.source.status.${status}`,
            }))}
        />
      </SimpleForm>
    </Create>
  );
};

export default createMerchantPaymentGateway;
